// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__+Vey2","errorText":"ErrorBoundary_errorText__JJcA1"};